import { render, staticRenderFns } from "./DatGui.vue?vue&type=template&id=5f436604&scoped=true&"
import script from "./DatGui.vue?vue&type=script&lang=js&"
export * from "./DatGui.vue?vue&type=script&lang=js&"
import style0 from "./DatGui.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DatGui.vue?vue&type=style&index=1&id=5f436604&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f436604",
  null
  
)

export default component.exports